import { TournamentFollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetTournamentFollowerCountUseCase {
  constructor(private tournamentFollowRepository: TournamentFollowRepository) {}

  async execute(tournamentId: string): Promise<number> {
    logger.debug('GetTournamentFollowerCount', 'Getting follower count', { tournamentId });

    const count = await this.tournamentFollowRepository.getFollowerCount(tournamentId);

    logger.debug('GetTournamentFollowerCount', 'Follower count', { count });

    return count;
  }
}
